// Convert GUID string to Base-64 in Javascript
// by Mark Seecof, 2012-03-31
const hexlist = '0123456789abcdef';
const b64list =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

// GUID string with four dashes is always MSB first, but base-64 GUID's vary by
// target-system endian-ness. The bytes are always reordered to little-endian
// here because that is the layout the backend (x86) expects, and it is the
// inverse of the reordering `base64ToGuid` applies when decoding.
//
const guidToBase64 = (g: string) => {
  let s = g.replace(/[^0-9a-f]/gi, '').toLowerCase();

  if (s.length !== 32) {
    return '';
  }
  s =
    s.slice(6, 8) +
    s.slice(4, 6) +
    s.slice(2, 4) +
    s.slice(0, 2) +
    s.slice(10, 12) +
    s.slice(8, 10) +
    s.slice(14, 16) +
    s.slice(12, 14) +
    s.slice(16);
  s += '0';

  let a, p, q;
  let r = '';
  let i = 0;

  while (i < 33) {
    a =
      (hexlist.indexOf(s.charAt(i++)) << 8) |
      (hexlist.indexOf(s.charAt(i++)) << 4) |
      hexlist.indexOf(s.charAt(i++));

    p = a >> 6;
    q = a & 63;
    r += b64list.charAt(p) + b64list.charAt(q);
  }
  r += '==';

  return r;
};

const base64ToGuid = (base64: string) => {
  let hex = '';

  for (let i = 0; i < base64.length; ) {
    const e1 = b64list.indexOf(base64[i++]);
    const e2 = b64list.indexOf(base64[i++]);
    const e3Char = base64[i++];
    const e4Char = base64[i++];
    const e3 = e3Char === '=' ? 64 : b64list.indexOf(e3Char);
    const e4 = e4Char === '=' ? 64 : b64list.indexOf(e4Char);
    const c1 = (e1 << 2) | (e2 >> 4);
    const c2 = ((e2 & 15) << 4) | (e3 >> 2);
    const c3 = ((e3 & 3) << 6) | e4;

    hex += hexlist[c1 >> 4];
    hex += hexlist[c1 & 15];
    if (e3 !== 64) {
      hex += hexlist[c2 >> 4];
      hex += hexlist[c2 & 15];
    }
    if (e4 !== 64) {
      hex += hexlist[c3 >> 4];
      hex += hexlist[c3 & 15];
    }
  }
  const a =
    hex.substring(6, 8) +
    hex.substring(4, 6) +
    hex.substring(2, 4) +
    hex.substring(0, 2);
  const b = hex.substring(10, 12) + hex.substring(8, 10);
  const c = hex.substring(14, 16) + hex.substring(12, 14);
  const d = hex.substring(16);

  hex = a + b + c + d;

  return (
    hex.substring(0, 8) +
    '-' +
    hex.substring(8, 12) +
    '-' +
    hex.substring(12, 16) +
    '-' +
    hex.substring(16, 20) +
    '-' +
    hex.substring(20)
  );
};

/**
 * given either a long or short GUID, return the short guid - does not validate the GUID
 * @param guid (long or short)
 */
export const guidToShortGuid = (guid: string): string => {
  const isLongGUID = guid.match(
    /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i
  ); //Long GUID format xxxxxxxx-yyyy-zzzz-aaaa-bbbbbbbbbbbb

  if (!isLongGUID) {
    return guid;
  }
  let encoded = guidToBase64(guid);

  encoded = encoded.replace(/\//g, '_').replace(/\+/g, '-');

  return encoded.substring(0, 22);
};

export const createGuid = (shortGuid: string): string => {
  let encoded = shortGuid.replace(/_/g, '/').replace(/-/g, '+');

  encoded = encoded + '==';

  return base64ToGuid(encoded);
};
